import { render } from "./LbrxListSales.vue?vue&type=template&id=0127d5b5"
import script from "./LbrxListSales.vue?vue&type=script&lang=js"
export * from "./LbrxListSales.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__